export const SHAPEFILE_SUCCESSFUL_UPLOAD = 'Shapefile successfully uploaded';
export const SHAPEFILE_VERIFIED = 'Shapefile verified';
export const SHAPEFILE_SEEK_CLARIFICATION = 'Shapefile seek clarification';
